import { accountSlice } from '@features/account/store';
import { authSlice } from '@features/auth/store';
import { constructorLoaderSlice, constructorSlice } from '@features/constructor';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
var rootReducer = combineReducers({
    authData: authSlice.reducer,
    userData: accountSlice.reducer,
    constructorData: constructorSlice.reducer,
    constructorLoader: constructorLoaderSlice.reducer,
});
export var store = configureStore({
    reducer: rootReducer,
});
